export class Header {
    constructor() {
        this.eventHandlers();
        this.setupPublicNavigation();
    }

    eventHandlers() {
        $(document.body).on('click', '#signin-form-container [data-nav-parent]', this.toggleSidebarChildren.bind(this));
        $(document.body).on('click', '#signin-form-container [data-nav-submenu] a', this.stopPropagation.bind(this));
        $(document.body).on('keydown', 'input[type=number]', this.disableKeydown.bind(this));
        $(document.body).on('focus', 'input[type=number]', this.disableScrollInNumberField.bind(this));
    }

    disableScrollInNumberField(e) {
        $(e.currentTarget).on('wheel.disableScroll', function (event) {
            event.preventDefault();
        });
    }

    stopPropagation(e) {
        e.stopPropagation();
    }

    disableKeydown(e) {
        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') e.preventDefault();
    }

    toggleSidebarChildren(e) {
        e.preventDefault();
        const item = $(e.currentTarget);
        if (item.hasClass('open')) {
            item.removeClass('open');
            item.find('[data-nav-submenu]').slideUp(100);
        } else {
            item.addClass('open');
            item.find('[data-nav-submenu]').slideDown(100);
        }
    }

    setupPublicNavigation() {
        const header = document.querySelector('#masthead.ng-public-header');
        if (!header) return;

        const navigation = header.querySelector('#site-navigation');
        const menuToggle = header.querySelector('#ng-public-menu-toggle');
        const desktop = window.matchMedia('(min-width: 1051px)');
        const disclosures = [...header.querySelectorAll('.ng-public-header__disclosure')];
        const closeTimers = new WeakMap();
        const openModes = new WeakMap();
        const panelFor = button => document.getElementById(button.getAttribute('aria-controls'));

        const closeDisclosure = button => {
            clearTimeout(closeTimers.get(button));
            button.setAttribute('aria-expanded', 'false');
            panelFor(button).hidden = true;
            openModes.delete(button);
            for (const child of panelFor(button).querySelectorAll('.ng-public-header__disclosure')) {
                closeDisclosure(child);
            }
        };
        const openDisclosure = (button, mode) => {
            clearTimeout(closeTimers.get(button));
            for (const other of disclosures) {
                if (other !== button && other.parentElement.parentElement === button.parentElement.parentElement) closeDisclosure(other);
            }
            button.setAttribute('aria-expanded', 'true');
            panelFor(button).hidden = false;
            openModes.set(button, mode);
        };
        const closeMenu = () => {
            disclosures.forEach(closeDisclosure);
            navigation.hidden = !desktop.matches;
            menuToggle.setAttribute('aria-expanded', 'false');
        };

        menuToggle.addEventListener('click', () => {
            if (!navigation.hidden) {
                closeMenu();
                return;
            }
            navigation.hidden = false;
            navigation.scrollTop = 0;
            menuToggle.setAttribute('aria-expanded', 'true');
        });

        for (const button of disclosures) {
            const panel = panelFor(button);
            const item = button.parentElement;
            button.addEventListener('click', event => {
                // A click after a mouse hover makes the disclosure stay open.
                if (panel.hidden || (openModes.get(button) === 'hover' && event.detail > 0)) {
                    openDisclosure(button, 'click');
                } else {
                    closeDisclosure(button);
                }
            });
            button.addEventListener('keydown', event => {
                if (event.key !== 'ArrowDown') return;
                event.preventDefault();
                openDisclosure(button, 'keyboard');
                const first = panel.querySelector('[role="tab"][aria-selected="true"]')
                    || panel.querySelector('a, button');
                if (first) first.focus();
            });
            item.addEventListener('pointerenter', event => {
                if (!desktop.matches || event.pointerType !== 'mouse') return;
                clearTimeout(closeTimers.get(button));
                if (panel.hidden) openDisclosure(button, 'hover');
            });
            item.addEventListener('pointerleave', event => {
                if (!desktop.matches || event.pointerType !== 'mouse') return;
                closeTimers.set(button, window.setTimeout(() => {
                    if (!item.contains(document.activeElement)) closeDisclosure(button);
                }, 160));
            });
        }

        for (const tablist of header.querySelectorAll('[role="tablist"]')) {
            const tabs = [...tablist.querySelectorAll('[role="tab"]')];
            const selectTab = tab => {
                for (const choice of tabs) {
                    const selected = tab === choice;
                    choice.setAttribute('aria-selected', String(selected));
                    choice.tabIndex = selected ? 0 : -1;
                    panelFor(choice).hidden = !selected;
                }
            };
            tablist.addEventListener('click', event => {
                const tab = event.target.closest('[role="tab"]');
                if (tabs.includes(tab)) selectTab(tab);
            });
            tablist.addEventListener('keydown', event => {
                const index = tabs.indexOf(event.target);
                if (index < 0) return;
                const nextKey = tablist.getAttribute('aria-orientation') === 'vertical' ? 'ArrowDown' : 'ArrowRight';
                const previousKey = tablist.getAttribute('aria-orientation') === 'vertical' ? 'ArrowUp' : 'ArrowLeft';
                let next;
                if (event.key === nextKey) next = (index + 1) % tabs.length;
                else if (event.key === previousKey) next = (index + tabs.length - 1) % tabs.length;
                else if (event.key === 'Home') next = 0;
                else if (event.key === 'End') next = tabs.length - 1;
                else return;
                event.preventDefault();
                selectTab(tabs[next]);
                tabs[next].focus();
            });
        }

        for (const eventName of ['click', 'focusin']) {
            document.addEventListener(eventName, event => {
                for (const button of disclosures) {
                    if (!button.parentElement.contains(event.target)) closeDisclosure(button);
                }
                if (!header.contains(event.target)) closeMenu();
            });
        }
        navigation.addEventListener('click', event => {
            if (event.target.closest('a')) closeMenu();
        });
        document.addEventListener('keydown', event => {
            if (event.key !== 'Escape') return;
            const open = disclosures.filter(button => button.getAttribute('aria-expanded') === 'true');
            const current = [...open].reverse().find(button => button.parentElement.contains(document.activeElement)) || open[open.length - 1];
            if (current) {
                event.preventDefault();
                closeDisclosure(current);
                current.focus();
            } else if (!desktop.matches && !navigation.hidden) {
                event.preventDefault();
                closeMenu();
                menuToggle.focus();
            }
        });
        desktop.addEventListener('change', closeMenu);
        closeMenu();

        const root = document.documentElement;
        const adminBar = document.getElementById('wpadminbar');
        const updateOffsets = () => {
            const adminBounds = adminBar ? adminBar.getBoundingClientRect() : null;
            const adminTop = adminBounds ? Math.max(0, adminBounds.bottom) : 0;
            root.style.setProperty('--ng-public-header-top', `${adminTop}px`);
            const bounds = header.getBoundingClientRect();
            root.style.setProperty('--ng-public-header-height', `${bounds.height}px`);
            root.style.setProperty('--ng-public-navigation-top', `${bounds.bottom}px`);
            // Preserve the first-screen composition after the mobile admin bar scrolls away.
            root.style.setProperty('--ng-public-hero-offset', `${bounds.height + (adminBounds ? adminBounds.height : 0)}px`);
        };
        const observer = new ResizeObserver(updateOffsets);
        observer.observe(header);
        if (adminBar) observer.observe(adminBar);
        window.addEventListener('resize', updateOffsets);
        window.addEventListener('scroll', updateOffsets, { passive: true });
        window.addEventListener('load', updateOffsets, { once: true });
        updateOffsets();
    }
}
